<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="CIDADÃOS"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/family.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/cidadaos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()"
            class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar cidadão
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
          style="width: 45px; height: 350px; border-right: 1px solid #ebebeb; margin-right: 10px">
          <img src="assets/img/global/curriculum_vitae.png" alt="">
        </div>
        <div class="col-md-11 col-lg-11 col-xl-11">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="selectTipo">Espécie<span class="text-danger">*</span></label>
              <select #tipo_ name="selectTipo" formControlName="especie" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaTipos">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label *ngIf="entidadeForm.get('especie').value === '1'" for="nome">CNPJ<span
                  class="text-danger">*</span></label>
              <p-inputMask *ngIf="entidadeForm.get('especie').value === '1'" id="cnpj" formControlName="cpf_cnpj"
                mask="99.999.999/9999-99" slotChar=" " styleClass="form-control">
              </p-inputMask>
              <label *ngIf="entidadeForm.get('especie').value === '2'" for="cnpj">CPF<span
                  class="text-danger">*</span></label>
              <p-inputMask *ngIf="entidadeForm.get('especie').value === '2'" id="cpf" formControlName="cpf_cnpj"
                mask="999.999.999-99" slotChar=" " styleClass="form-control">
              </p-inputMask>
              <label *ngIf="entidadeForm.get('especie').value !== '1' && entidadeForm.get('especie').value !== '2'"
                for="cnpj">
                Inscrição<span class="text-danger">*</span>
              </label>
              <input formControlName="cpf_cnpj"
                *ngIf="entidadeForm.get('especie').value !== '1' && entidadeForm.get('especie').value !== '2'" id="cnpj"
                class="form-control" />
            </div>
            <div class="form-group col-md-3">
              <div class="form-group col-md-12">
                <label for="cartao">Cartão<span class="text-danger">*</span></label>
                <input formControlName="cartao" type="text" class="form-control" id="cartao">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="nome">Nome<span class="text-danger">*</span></label>
              <input formControlName="nome" type="text" class="form-control font-weight-bold" id="nome">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="email">e-mail<span class="text-danger">*</span></label>
              <input formControlName="email" type="text" class="form-control font-weight-bold" id="email">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-3">
              <label for="telefone">Telefone<span class="text-danger">*</span></label>
              <input formControlName="telefone" type="text" class="form-control font-weight-bold" id="telefone">
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
          style="width: 45px; height: 325px; border-right: 1px solid #ebebeb; margin-right: 10px">
          <img src="assets/img/global/direction.png" alt="liquida">
        </div>
        <div class="col-md-11 col-lg-11 col-xl-11">

          <div class="row">
            <div class="form-group col-md-3">
              <label for="cep">CEP<span class="text-danger">*</span></label>
              <p-inputMask id="cep" formControlName="cep" mask="99.999-999" slotChar=" " styleClass="form-control">
              </p-inputMask>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-10">
              <label for="endereco">Endereço<span class="text-danger">*</span></label>
              <input formControlName="endereco" type="text" class="form-control" id="endereco">
            </div>
            <div class="form-group col-md-2">
              <label for="num_end">Número<span class="text-danger">*</span></label>
              <input formControlName="numero" type="text" class="form-control" id="num_end">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="bairro">Bairro<span class="text-danger">*</span></label>
              <input formControlName="bairro" type="text" class="form-control" id="bairro">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="bairro">Cidade<span class="text-danger">*</span></label>
              <input formControlName="municipio" type="text" class="form-control">
            </div>
          </div>

        </div>
      </div>
      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>
